// import React, { useState } from 'react';
import { ButtonK } from '@datascient/datascient-ui-library';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,

} from '@mui/material';

const TermsofUseDialog = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} sx={{borderRadius:'20px'}}>
      <DialogTitle>Terms of Use</DialogTitle>
      <DialogContent
        sx={{ marginTop: '2px', height: '40%', overflow: 'auto' }}
      >
        {/* <DialogContentText>
          <iframe
      title="WebPage"
      width="100%"
      height="500px"
      src="https://datascient.ai/terms-of-service/" // Replace this URL with the webpage URL you want to display
     
    ></iframe>
    </DialogContentText> */}
        <DialogContentText sx={{border:'2px solid #000',padding:'10px'}}>
          For datascient.ai customers: If your organization signed an offline
          agreement for the use of datascient.ai Software and Services, then your
          offline agreement governs your organization’s use of datascient.ai Site,
          Software, and Services.
          <br />
          <br />
          Together with its subsidiaries and other affiliates, ishield
          technologies, Inc., a Delaware corporation (“datascient.ai”), makes
          available the “Site” (websites including, without limitation,
          www.datascient.ai and all subdomains), “Software” (software, API and mobile
          applications), and “Services” (including, without limitation, writing
          feedback suggestions and/or corrections, unconscious bias detection,
          toxicity detection, abuse detection, disinformation detection, and
          human proofreading services) to help people communicate in a bias and
          toxicity free manner.
          <br />
          <br />
          Access to and use of datascient.ai’s existing Site, Software and Services,
          as well as any future Sites, Software or Services provided by datascient.ai
          are governed by this Terms of Service and License Agreement (this
          “Agreement”).
          <br />
          <br />
          THIS IS A LEGALLY BINDING AGREEMENT. IF YOU DO NOT UNDERSTAND THIS
          AGREEMENT, OR DO NOT AGREE TO BE BOUND BY IT OR THE PRIVACY POLICY
          REFERENCED HEREIN, YOU MUST IMMEDIATELY LEAVE THE SITE AND YOU ARE NOT
          AUTHORIZED TO ACCESS OR USE ANY OF THE SERVICES OR SOFTWARE. BY
          ACCESSING OR USING THE SITE, SERVICES AND/OR SOFTWARE, YOU CONFIRM
          THAT YOU ARE AT LEAST 18 YEARS OLD, THAT YOU ARE LEGALLY ABLE TO ENTER
          INTO THIS AGREEMENT, AND THAT YOU HAVE READ, UNDERSTAND AND AGREE TO
          BE BOUND BY THIS AGREEMENT.
          <br />
          <br />
          If you are an individual subscriber, or are accessing the Site to use
          a Trial (as defined below) of the Services or Software, or are
          otherwise browsing the Site, this Agreement is between you,
          individually, and datascient.ai.
          <br />
          <br />
          If you are an employee, faculty member or student of a university,
          school or other entity or organization that has subscribed to the
          Services and Software (an “Enterprise Subscriber”), you are an
          “Authorized User” of your Enterprise Subscriber and (i) you represent
          that you have your Enterprise Subscriber’s permission and authority to
          use the Site, Services, Software and your Enterprise Subscriber’s
          “User Content” (as defined below) subject to this Agreement, (ii) this
          Agreement is an agreement between you, individually, and datascient.ai, and
          (iii) your Enterprise Subscriber is jointly responsible for your use
          of the Site, Services and Software.
          <br />
          <br />
          If you are entering into this Agreement on behalf of an Enterprise
          Subscriber, you represent that you have the authority to bind the
          Enterprise Subscriber to this Agreement, in which case references to
          “you” in this Agreement shall mean the Enterprise Subscriber. If you
          do not have such authority, you must not accept this Agreement and may
          not use the Site, Software or Services.
          <br />
          <br />
        
        </DialogContentText>
      </DialogContent>
    
        <ButtonK   onClick={handleClose}>
          Got It
        </ButtonK>
        <ButtonK
              text="Got It"
              color="#131F32"
              backgroundColor="#FFD600"
              varient="filled"
              handleClick={handleClose}
              sx={{ fontSize:'16px',fontWeight:'600',width:'150px',marginBottom:'10px',marginLeft:'38%'}} 
            />
     
    </Dialog>
  );
};

export default TermsofUseDialog;
